import React from 'react'
import { Avatar, ListItem, ListItemAvatar, ListItemText } from '@mui/material'
import { VistitorEater } from '../../../../../types/dashboard'

interface VisitorUserDetailProps {
  visitor: VistitorEater
  secondaryAction?: React.ReactNode
}

const VisitorUserDetail: React.FC<VisitorUserDetailProps> = ({
  visitor,
  secondaryAction,
}) => {
  return (
    <ListItem
      sx={{
        py: '4px',
        px: 0,
      }}
      secondaryAction={secondaryAction}
    >
      <ListItemAvatar>
        <Avatar sizes="36px" src={visitor?.imageUrl ?? visitor?.name}></Avatar>
      </ListItemAvatar>
      <ListItemText
        primaryTypographyProps={{
          variant: 'subtitle1',
          fontWeight: 500,
          color: 'grey.800',
        }}
        secondaryTypographyProps={{
          variant: 'subtitle2',
          color: 'grey.400',
        }}
        primary={
          visitor?.name === 'null null' ? 'Anonymous user' : visitor?.name
        }
        secondary={
          visitor?.email?.endsWith('@okaoinc.com') ? '' : visitor?.email
        }
      />
    </ListItem>
  )
}

export default VisitorUserDetail
